<template>
  <v-layout row wrap>
    <v-flex xs12 sm9 md10 class="text-md-left">
      <strong>{{text_label}}</strong>
      <v-divider/>
    </v-flex>
    <v-flex xs12 sm3 md2 class="text-md-right text-sm-right">
      <v-btn color="primary" class="mb-2" dark @click="StartSign">
        {{ text_label }}
      </v-btn>
    </v-flex>
    <v-flex xs12 sm9 md10>
      <canvas :id="id_canvas" :name="id_canvas" width="500" height="100" ref="signature"/>
    </v-flex>
    <v-flex xs12 sm12 md12>
      <input type="hidden" name="bioSigData"/>
      <textarea :name="name_sigraw" rows="10" cols="32" style="resize: none; display: none;">
        Signature Raw Data:
      </textarea>
    </v-flex>
    <v-flex xs12 sm12 md12>
      <input type="hidden" name="sigImgData"/>
      <textarea :name="name_sigimg" rows="10" cols="32" style="resize: none; display: none;">
        Signature Image Data:
      </textarea>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'firma',
  props: {
    value: {
      type: Array,
      required: true,
    },
    text_label: {
      type: String,
      required: false,
      default: 'Firmar',
    },
    id_canvas: {
      type: String,
      required: false,
      default: 'cnv',
    },
    name_form: {
      name_form: String,
      required: false,
      default: 'FORM1',
    },
    name_sigraw: {
      type: String,
      required: false,
      default: 'sigRawData',
    },
    name_sigimg: {
      type: String,
      required: false,
      default: 'sigImageData',
    },
  },
  data() {
    return {
      signatures: this.value,
    };
  },
  methods: {
    StartSign() {
      this.signatures = [];
      this.$emit('input', this.signatures);
      const canvasObj = document.getElementById(this.id_canvas);
      canvasObj.getContext('2d').clearRect(0, 0, canvasObj.width, canvasObj.height);
      document.getElementsByName(this.name_sigraw)[0].value = 'Signature Raw Data: ';
      document.getElementsByName(this.name_sigimg)[0].value = 'Signature Image Data: ';
      this.imgWidth = canvasObj.width;
      this.imgHeight = canvasObj.height;
      const message = {
        firstName: '',
        lastName: '',
        eMail: '',
        location: '',
        imageFormat: 1,
        imageX: this.imgWidth,
        imageY: this.imgHeight,
        imageTransparency: false,
        imageScaling: false,
        maxUpScalePercent: 0.0,
        rawDataFormat: 'ENC',
        minSigPoints: 25,
        penThickness: 3,
        penColor: '#000000',
      };
      document.addEventListener('SigCaptureWeb_SignResponse', this.SignResponse, false);
      const messageData = JSON.stringify(message);
      const element = document.createElement('SigCaptureWeb_ExtnDataElem');
      element.setAttribute('SigCaptureWeb_MsgAttribute', messageData);
      document.documentElement.appendChild(element);
      const evt = document.createEvent('Events');
      evt.initEvent('SigCaptureWeb_SignStartEvent', true, false);
      element.dispatchEvent(evt);
    },
    SignResponse(event) {
      const str = event.target.getAttribute('SigCaptureWeb_msgAttri');
      const obj = JSON.parse(str);
      this.SetValues(obj, this.imgWidth, this.imgHeight);
    },
    SetValues(objResponse, imageWidth, imageHeight) {
      const obj = JSON.parse(JSON.stringify(objResponse));
      const ctx = document.getElementById(this.id_canvas).getContext('2d');

      if (obj.errorMsg != null && obj.errorMsg !== '' && obj.errorMsg !== 'undefined') {
        alert(obj.errorMsg);
      } else if (obj.isSigned) {
        document.getElementsByName(this.name_sigraw)[0].value += obj.rawData;
        document.getElementsByName(this.name_sigimg)[0].value += obj.imageData;
        const img = new Image();
        img.onload = function () {
          ctx.drawImage(img, 0, 0, imageWidth, imageHeight);
        };
        img.src = `data:image/png;base64,${obj.imageData}`;
        this.baseImg = img.src;
        this.signatures.push(`${obj.imageData}`);
        this.$emit('input', this.signatures);
      }
      document.removeEventListener('SigCaptureWeb_SignResponse', this.SignResponse);
    },
    ClearFormData() {
      document.getElementsByName(this.name_sigimg)[0].value = 'Signature Raw Data: ';
      document.getElementsByName(this.name_sigimg)[0].value = 'Signature Image Data: ';
    },
  },
  mounted() {
    this.ClearFormData();
  },
};
</script>

<style scoped>

</style>
